interface DayDividerProps {
  label: string;
}

export function DayDivider({ label }: DayDividerProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-2 my-2">
      <div className="flex-1 border-t border-dark-border" />
      <span className="text-xs text-gray-500">{label}</span>
      <div className="flex-1 border-t border-dark-border" />
    </div>
  );
}
